import React from "react";

type LibrarySubtabIntroProps = {
  title?: string;
  children?: React.ReactNode;
};

const LibrarySubtabIntro: React.FC<LibrarySubtabIntroProps> = ({
  title,
  children,
}) => {
  if (!title && !children) return null;

  return (
    <div className="mb-5 rounded-2xl border border-gray-200 bg-gray-50 px-4 py-5">
      {title && (
        <h2 className="mb-2 text-[19px] font-semibold leading-[28px] text-gray-900">
          {title}
        </h2>
      )}

      {children && (
        <p className="m-0 text-[14px] leading-[22px] text-gray-600">
          {children}
        </p>
      )}
    </div>
  );
};

export default LibrarySubtabIntro;
